const styles = theme => ({
  container: {
    display: 'inline-flex',
    alignItems: 'flex-start',
    fontSize: '14px',
    lineHeight: '21px',
    border: '1px solid red',
    borderRadius: '0px',
    padding: '0.8em 1em',
    width: '100%',
    '& img': {
      marginRight: '6px',
      width: '18px',
      height: '18px',
    },
  },
  info: {
    borderColor: theme.palette.primary.infoBlue,
    background: theme.palette.primary.infoBlueLight,
    color: theme.palette.primary.adgmInfo,
  },
  mute: {
    borderColor: theme.palette.primary.darkGrey,
    background: theme.palette.primary.grey,
    color: theme.palette.primary.darkGrey,
  },
  error: {
    borderColor: '#E95635',
    background: theme.palette.primary.dangerRedLight,
    color: theme.palette.primary.adgmBlack,
  },
  warning: {
    borderColor: theme.palette.secondary.warningMangoDark,
    background: theme.palette.primary.warningMangoLight,
    color: theme.palette.primary.adgmBlack,
  },
  success: {
    borderColor: theme.palette.primary.adgmSuccess,
    background: theme.palette.primary.successGreenLight,
    color: theme.palette.primary.adgmBlack,
  },
  fullWidth: {
    width: '100%',
  },
  noBackground: {
    background: 'none',
    border: 'none',
    padding: '0',
  },
  background: {
    color: theme.palette.primary.acscent,
  },
  blackColor: {
    color: '#130F26',
  },
  smoothBorderRaduis: {
    borderRadius: '0px !important',
  },
  '@media (max-width:767px)': {
    container: {
      fontSize: '12px',
      '& img': {
        marginRight: '4px',
        marginTop: '3px',
        width: '14px',
        height: '14px',
      },
    },
  },
});

export default styles;
